/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useTranslatedText } from '../../../hooks/common/use-translated-text'
import { UiIcon } from '../icons/ui-icon'
import { UserAvatarForUsername } from '../user-avatar/user-avatar-for-username'
import type { PermissionDisabledProps } from './permission-disabled.prop'
import React, { Fragment } from 'react'
import { Button } from 'react-bootstrap'
import { Pencil as IconPencil } from 'react-bootstrap-icons'
import { GuestUserAvatar } from '../user-avatar/guest-user-avatar'
import { useNoteSettingsContext } from '../note-settings/note-settings-context'

export interface PermissionOwnerInfoProps {
  onEditOwner: () => void
}

/**
 * Content for the owner section of the permission modal that shows the current note owner.
 *
 * @param onEditOwner Callback that is fired when the user chooses to change the note owner.
 * @param disabled If the user is not the owner, functionality is disabled.
 */
export const PermissionOwnerInfo: React.FC<PermissionOwnerInfoProps & PermissionDisabledProps> = ({
  onEditOwner,
  disabled
}) => {
  const noteOwner = useNoteSettingsContext().permissions.owner
  const buttonTitle = useTranslatedText('editor.modal.permissions.ownerChange.button')

  if (!noteOwner) {
    return <GuestUserAvatar />
  }

  return (
    <Fragment>
      <UserAvatarForUsername username={noteOwner} />
      <Button variant='primary' disabled={disabled} title={buttonTitle} onClick={onEditOwner}>
        <UiIcon icon={IconPencil} />
      </Button>
    </Fragment>
  )
}
